import filePdfIconUrl from 'assets/images/pdf-file.png'
import axios from 'axios'
import { authHeaderFor } from 'helpers'
import { useEffect, useState } from 'react'
import { Download } from 'react-feather'
import { Spinner } from 'reactstrap'

const PMBImageWithToken = ({ source, token, fallback, noToken, testId = 'pmb-image-with-token', ...props }) => {
  const [blobUrl, setBlobUrl] = useState('')
  const [mimeType, setMimeType] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [isError, setIsError] = useState(false)
  const [isDownload, setIsDownload] = useState(false)

  useEffect(() => {
    let isMounted = true

    const fetchFile = async () => {
      try {
        const config = {
          responseType: 'blob',
        }

        if (!noToken) {
          config.headers = authHeaderFor(source, token)
        }

        const response = await axios.get(source, config)

        const url = URL.createObjectURL(response.data)

        if (isMounted) {
          setBlobUrl(url)
          setMimeType(response.data.type)
          setIsLoading(false)
        }
      } catch (error) {
        console.error('Terjadi kesalahan saat memuat file dengan token', error)
        if (isMounted) {
          setIsError(true)
          setIsLoading(false)
        }
      }
    }

    fetchFile()

    return () => {
      isMounted = false
      if (blobUrl) URL.revokeObjectURL(blobUrl)
    }
  }, [source, token])

  if (isLoading) return <Spinner size="sm" color="primary" data-testid={`${testId}-loading`} />

  if (isError && fallback) return <img src={fallback} data-testid={testId} {...props} />

  const handleDownload = () => {
    if (isDownload) return

    setIsDownload(true)

    const fileName = 'document.pdf'

    const link = document.createElement('a')
    link.href = blobUrl
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    setTimeout(() => {
      setIsDownload(false)
    }, 3000)
  }

  if (mimeType === 'application/pdf') {
    return (
      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: '6px',
          width: '100px',
          height: '100px',
          boxSizing: 'border-box',
          overflow: 'hidden',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'relative',
          backgroundImage: `url(${filePdfIconUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          }}
        />

        <div
          style={{
            position: 'relative',
            zIndex: 1,
            backgroundColor: '#006386',
            borderRadius: '50%',
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'background-color 0.3s ease',
            width: '40px',
            height: '40px',
            cursor: 'pointer',
          }}
          disabled={isDownload}
          data-testid={`${testId}-download`}
          onClick={handleDownload}
        >
          {isDownload ? (
            <Spinner size="sm" style={{ color: '#fff' }} />
          ) : (
            <Download color="#fff" />
          )}
        </div>
      </div>
    )
  }

  return <img src={blobUrl} alt="Preview" data-testid={testId} {...props} />
}

export default PMBImageWithToken
